/**
 * Badge component for labels and status indicators.
 */
import * as stylex from "@stylexjs/stylex";

import { colors, fontSize, radius, space } from "../tokens.stylex";

const styles = stylex.create({
  base: {
    display: "inline-block",
    borderRadius: radius.sm,
    paddingInline: space.sm,
    paddingBlock: 2,
    fontSize: fontSize.xs,
    textTransform: "capitalize",
  },
  neutral: {
    backgroundColor: colors.muted,
    color: colors.foregroundMuted,
  },
  blue: {
    backgroundColor: "rgba(59,130,246,0.2)",
    color: colors.primary,
  },
  green: {
    backgroundColor: "rgba(34,197,94,0.2)",
    color: colors.success,
  },
  red: {
    backgroundColor: "rgba(239,68,68,0.2)",
    color: colors.destructive,
  },
  yellow: {
    backgroundColor: "rgba(234,179,8,0.2)",
    color: colors.warning,
  },
  purple: {
    backgroundColor: "rgba(168,85,247,0.2)",
    color: "#c084fc",
  },
  orange: {
    backgroundColor: "rgba(249,115,22,0.2)",
    color: "#fb923c",
  },
});

type BadgeVariant =
  | "neutral"
  | "blue"
  | "green"
  | "red"
  | "yellow"
  | "purple"
  | "orange";

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  xstyle?: stylex.StyleXStyles;
}

function Badge({ variant = "neutral", xstyle, ...props }: BadgeProps) {
  return (
    <span {...stylex.props(styles.base, styles[variant], xstyle)} {...props} />
  );
}

// Export style variants for direct use with stylex.props()
export const badge = styles;

export { Badge, type BadgeProps, type BadgeVariant };
